export enum CouponTypes {
    FIXED = 'df432b8c-3a35-412a-915e-bc5901f28d3d',
    FLOATING = '54c954ed-35a9-42d4-87af-40cb546a02f5'
}